import RxSelect from './Select';

const Select = RxSelect;

export default Select;
